export default "__VITE_ASSET__owDdlyDL__"